<script setup lang="ts">
import { useRoute } from "vue-router";
import { twMerge } from "tailwind-merge";
import Divider from "./Divider.vue";
import Lucide from "../../base-components/Lucide";
import {
  FormattedMenu,
  nestedMenu,
} from "@/components/MainMenu/main-menu";
import { watch, reactive, computed, onMounted, ref } from "vue";
import SimpleBar from "simplebar";
import { useStore } from "vuex";
import { setRoutes } from "@/services/router/router.service";
import MobileMenuComponent from "./MobileMenuComponent.vue";

const store = useStore();

const setMenuFixed = ref(false);

const route = useRoute();
const menuLayout = "side-menu";
const formattedMenu = ref([]);
const setFormattedMenu = (
  computedFormattedMenu: Array<FormattedMenu | "divider">
) => {
  formattedMenu.value = computedFormattedMenu;
};
const sideMenu = computed(() => nestedMenu(store.state.menu, route));

const activeMobileMenu = ref(false);

const setActiveMobileMenu = (active: boolean) => {
  if (active) {
    // @ts-ignore
    document.getElementById("sub-main").classList.add("hidden");
    // @ts-ignore
    document.getElementById("sub-platform").classList.add("hidden");
  } else {
    // @ts-ignore
    document.getElementById("sub-main").classList.remove("hidden");
    // @ts-ignore
    document.getElementById("sub-platform").classList.remove("hidden");
  }
  activeMobileMenu.value = active;
};

// @ts-ignore
const scrollableRef = ref<HTMLDivElement>();

watch(
  computed(() => route.path),
  () => {
    // @ts-ignore
    setFormattedMenu(nestedMenu(store.state.menu, route));
  }
);

watch(
  () => store.state.menu,
  function () {
    const url = window.location.href;
    var path = url.split("/")[3];
    if (path.includes("?")) {
      path = path.split("?")[0];
    }
    setFormattedMenu(sideMenu.value);
  }
);

function scrollTrigger() {
  if (window.pageYOffset > 112) {
    setMenuFixed.value = true;
  } else {
    setMenuFixed.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", scrollTrigger);
  if (scrollableRef.value) {
    new SimpleBar(scrollableRef.value);
  }

  setFormattedMenu(sideMenu.value);
});
</script>

<template>
  <!-- BEGIN: Mobile Menu -->
  <div
    :class="[
      {
        'fixed top-0': setMenuFixed,
        'absolute ': !setMenuFixed,
      },
      'w-full bg-primary/90 z-[51] border-b border-white/[0.08] mb-6 dark:bg-darkmode-800/90 md:hidden',
      'before:content-[\'\'] before:w-full before:h-screen before:z-10 before:fixed before:inset-x-0 before:bg-black/90 before:transition-opacity before:duration-200 before:ease-in-out',
      !activeMobileMenu && 'before:invisible before:opacity-0',
      activeMobileMenu && 'before:visible before:opacity-100',
    ]"
  >
    <div class="h-[70px] px-4 sm:px-6 flex justify-end items-center">
      <a @click="(e) => e.preventDefault()">
        <Lucide
          icon="BarChart2"
          class="w-8 h-8 text-white transform -rotate-90"
          @click="
            () => {
              setActiveMobileMenu(!activeMobileMenu);
            }
          "
        />
      </a>
    </div>
    <div
      ref="scrollableRef"
      :class="
        twMerge([
          'h-screen z-20 top-0 left-0 w-[270px] -ml-[100%] bg-primary transition-all duration-300 ease-in-out dark:bg-darkmode-800',
          '[&[data-simplebar]]:fixed [&_.simplebar-scrollbar]:before:bg-black/50',
          activeMobileMenu && 'ml-0',
        ])
      "
    >
      <a
        @click="(e) => e.preventDefault()"
        :class="[
          'fixed top-0 right-0 mt-4 mr-4 transition-opacity duration-200 ease-in-out',
          !activeMobileMenu && 'invisible opacity-0',
          activeMobileMenu && 'visible opacity-100',
        ]"
      >
        <Lucide
          icon="XCircle"
          class="w-8 h-8 text-white transform -rotate-90"
          @click="
            () => {
              setActiveMobileMenu(!activeMobileMenu);
            }
          "
        />
      </a>
      <ul class="py-2">
        <MobileMenuComponent
          v-for="(menu, index) in formattedMenu"
          :key="index"
          :menuIndex="index"
          :menu="menu"
          :isRoot="true"
          :setActiveMobileMenu="setActiveMobileMenu"
        >
        </MobileMenuComponent>
      </ul>
    </div>
  </div>
  <!-- END: Mobile Menu -->
</template>
